// extracted by mini-css-extract-plugin
module.exports = {"summary":"_1_j7gfHaIG1N1c8xRm6rY_","row":"_7Gu_S_HrZnf5UExRz1Nkv"};